module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-items-bg-sp-7d2ce89fabb72c052babe018cd31f9ec.png";